import React from 'react';
import {
  FDIcon, FDStack, FDTable, FDTableHead, FDTableBody, FDTableRow, FDTableCell,
  FDHeadlineText,
  FDLabelText,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'src/Hooks/useMobileLayout';
import { Richtext } from 'src/Packages/FacetDesign/Components/Richtext';

const getIconColor = (icon, idx) => {
  const val = icon.attr('value');
  if (val === 'closeOutline') { return 'textDisabled'; }

  return idx % 2 === 0 ? 'textPrimary' : 'primary';
};

const TaxHomeCompare = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const compare = resource.attr('compare').resources().list()?.[0];
  const columns = compare.attr('columnLabels').resources().list();
  const rows = compare.attr('rowSets').resources().list()?.[0]?.attr('rows').resources().list();

  return (
    <FDStack direction="column" justify="center" width="100%">
      <FDTable size="md" rowDividers>
        <FDTableHead>
          <FDTableRow>
            <FDTableCell flex={2}>
              <FDHeadlineText size={isMobile ? 'sm' : 'lg'} color="textSecondary" value={columns[0].attr('label')} />
            </FDTableCell>
            {
              columns.slice(1)?.map((field, idx) => (
                <FDTableCell align="center" width={'100%'} flexShrink={0}>
                  <FDLabelText
                    size="md"
                    color={idx % 2 === 0 ? 'textPrimary' : 'textSecondary'}
                    value={field?.attr('label')}
                    minWidth={'250px'}
                  />
                </FDTableCell>
              ))
            }
          </FDTableRow>
        </FDTableHead>
        <FDTableBody>
          { rows.map(row => <TaxHomeCompareRow cells={row.attr('cells')?.resources().list()} />)}
        </FDTableBody>
      </FDTable>
    </FDStack>
  );
};

const TaxHomeCompareRow = ({ cells }) => {
  const description = cells?.[0];
  const icons = cells?.slice(1);

  return (
    <>
      <FDTableRow>
        <FDTableCell>
          {
            description.attr('value') === ''
              ? <Richtext value={description.attr('richtextValue')} richtext />
              : description.attr('value')
          }

        </FDTableCell>
        { icons.map((icon, idx) => (
          <FDTableCell align="center">
            <FDIcon
              icon={icon.attr('value')}
              color={getIconColor(icon, idx)}
              size="md"
            />
          </FDTableCell>
        ))
        }
      </FDTableRow>
    </>
  );
};

export { TaxHomeCompare };
